import { Directive, ElementRef, Input, OnInit, OnDestroy, Renderer2, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[appScrollReveal]',
  standalone: true,
})
export class ScrollRevealDirective implements OnInit, OnDestroy {
  @Input('appScrollReveal') delay: string = '0s';
  @Input() revealClass: string = 'revealed';

  private observer!: IntersectionObserver;
  private readonly isBrowser: boolean;

  constructor(
    private readonly el: ElementRef,
    private readonly renderer: Renderer2,
    @Inject(PLATFORM_ID) platformId: object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    // Only execute animations and DOM manipulations in the browser
    if (this.isBrowser) {
      // Set initial state
      this.renderer.setStyle(this.el.nativeElement, 'transition-delay', this.delay);
      this.renderer.addClass(this.el.nativeElement, 'reveal-hidden');

      this.observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.renderer.addClass(this.el.nativeElement, this.revealClass);
              this.renderer.removeClass(this.el.nativeElement, 'reveal-hidden');
              this.observer.unobserve(this.el.nativeElement); // Only animate once
            }
          });
        },
        {
          threshold: 0.15, // Trigger when 15% visible
          rootMargin: '0px 0px -50px 0px',
        }
      );

      this.observer.observe(this.el.nativeElement);
    } else {
      // For SSR, ensure elements are visible by default
      this.renderer.addClass(this.el.nativeElement, this.revealClass);
    }
  }

  ngOnDestroy(): void {
    if (this.isBrowser && this.observer) {
      this.observer.disconnect();
    }
  }
}
